import { Flex } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import * as styles from "./styles_vanilla.css";

/** Two-column row (left: form controls, right: live preview) used to lay
 * out every editable section inside `DataFormatSection`. */
export const DataFormatRow = ({
  field,
  previewLabel,
  preview,
}: {
  field: React.ReactNode;
  previewLabel?: React.ReactNode;
  preview: React.ReactNode;
}) => (
  <Flex alignItems="flex-start" gap={SPACING.LARGE} className={styles.dataFormatRow}>
    <Flex flexDirection="column" gap={SPACING.MEDIUM} className={styles.dataFormatLeftCol}>
      {field}
    </Flex>
    <Flex flexDirection="column" gap={SPACING.X_SMALL} className={styles.dataFormatRightCol}>
      {previewLabel}
      <div className={styles.previewBox}>{preview}</div>
    </Flex>
  </Flex>
);
